class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm.id !== 'FacetFiltersFormMobile') {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
        // Element already rendered in the DOM so just update the innerHTML and className
        if (currentElement) {
          document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
          document.getElementById(elementToRender.id).className = elementToRender.className;
        } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.mobile-quick-filters'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input:not([type="range"])').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input:not([type="range"])');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class DoubleRangeSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.price-range-track');
    this.rangeMin = this.querySelector('.range-min');
    this.rangeMax = this.querySelector('.range-max');
    
    // Find sibling text inputs inside the parent <price-range> element
    const priceRangeElement = this.closest('price-range');
    if (!priceRangeElement) return;
    
    const inputs = priceRangeElement.querySelectorAll('input[type="text"]');
    if (inputs.length < 2) return;
    
    this.inputMin = inputs[0];
    this.inputMax = inputs[1];
    
    // Sync range values from text inputs initially
    const minVal = parseFloat(this.inputMin.value.replace(/[^0-9.]/g, '')) || 0;
    const maxVal = parseFloat(this.inputMax.value.replace(/[^0-9.]/g, '')) || parseFloat(this.rangeMin.max) || 100;
    this.rangeMin.value = minVal;
    this.rangeMax.value = maxVal;
    
    // Bind events for range inputs
    this.rangeMin.addEventListener('input', this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener('input', this.onRangeMaxInput.bind(this));
    
    // Bind events for text inputs to update range sliders
    this.inputMin.addEventListener('change', this.onTextInputChange.bind(this));
    this.inputMax.addEventListener('change', this.onTextInputChange.bind(this));
    
    // Bind pointer events to dynamically change z-index of range inputs based on proximity
    this.addEventListener('pointermove', this.adjustZIndex.bind(this));
    this.addEventListener('pointerdown', this.adjustZIndex.bind(this));
    
    this.isDragging = false;
    this.rangeMin.addEventListener('pointerdown', () => this.isDragging = true);
    this.rangeMax.addEventListener('pointerdown', () => this.isDragging = true);
    
    this._onPointerUp = () => this.isDragging = false;
    document.addEventListener('pointerup', this._onPointerUp);
    
    // Initial track update
    this.updateTrack();
  }
  
  disconnectedCallback() {
    if (this._onPointerUp) {
      document.removeEventListener('pointerup', this._onPointerUp);
    }
  }
  
  adjustZIndex(e) {
    if (this.isDragging) return;
    const rect = this.getBoundingClientRect();
    const clickPercent = (e.clientX - rect.left) / rect.width;
    const maxLimit = parseInt(this.rangeMin.max) || 100;
    const clickValue = clickPercent * maxLimit;
    
    const minDiff = Math.abs(parseInt(this.rangeMin.value) - clickValue);
    const maxDiff = Math.abs(parseInt(this.rangeMax.value) - clickValue);
    
    if (minDiff < maxDiff) {
      this.rangeMin.style.zIndex = '10';
      this.rangeMax.style.zIndex = '0';
    } else {
      this.rangeMin.style.zIndex = '0';
      this.rangeMax.style.zIndex = '10';
    }
  }
  
  updateTrack() {
    const minVal = parseInt(this.rangeMin.value) || 0;
    const maxVal = parseInt(this.rangeMax.value) || 0;
    const maxLimit = parseInt(this.rangeMin.max) || 100;
    
    if (maxLimit === 0) return;
    
    const leftPercent = (minVal / maxLimit) * 100;
    const rightPercent = 100 - (maxVal / maxLimit) * 100;
    
    this.track.style.left = leftPercent + '%';
    this.track.style.right = rightPercent + '%';
  }
  
  onRangeMinInput() {
    let minVal = parseInt(this.rangeMin.value) || 0;
    const maxVal = parseInt(this.rangeMax.value) || 0;
    
    if (minVal > maxVal) {
      this.rangeMin.value = maxVal;
      minVal = maxVal;
    }
    
    this.inputMin.value = minVal;
    this.updateTrack();
    
    // Trigger input event on the text input so form submissions work
    this.inputMin.dispatchEvent(new Event('input', { bubbles: true }));
  }
  
  onRangeMaxInput() {
    const minVal = parseInt(this.rangeMin.value) || 0;
    let maxVal = parseInt(this.rangeMax.value) || 0;
    
    if (maxVal < minVal) {
      this.rangeMax.value = minVal;
      maxVal = minVal;
    }
    
    this.inputMax.value = maxVal;
    this.updateTrack();
    
    // Trigger input event on the text input so form submissions work
    this.inputMax.dispatchEvent(new Event('input', { bubbles: true }));
  }
  
  onTextInputChange() {
    // Parse values from text inputs
    let minVal = parseFloat(this.inputMin.value.replace(/[^0-9.]/g, '')) || 0;
    let maxVal = parseFloat(this.inputMax.value.replace(/[^0-9.]/g, '')) || parseFloat(this.rangeMin.max);
    
    const maxLimit = parseInt(this.rangeMin.max) || 100;
    
    if (minVal < 0) minVal = 0;
    if (maxVal > maxLimit) maxVal = maxLimit;
    if (minVal > maxVal) minVal = maxVal;
    
    this.rangeMin.value = minVal;
    this.rangeMax.value = maxVal;
    
    this.updateTrack();
  }
}

customElements.define('double-range-slider', DoubleRangeSlider);


// Custom logic for quick filter pills opening specific sections
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.js-open-filter-drawer');
  if (!trigger) return;

  event.preventDefault();
  const filterName = (trigger.getAttribute('data-filter-name') || trigger.innerText).trim().toLowerCase();

  const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper details');
  if (!menuDrawer) return;

  const summaryToggle = menuDrawer.querySelector('summary.mobile-facets__open-wrapper');
  if (summaryToggle && !menuDrawer.hasAttribute('open')) {
    summaryToggle.click();
  }

  const mobileFacetsDetails = menuDrawer.querySelectorAll('.mobile-facets__details');

  setTimeout(() => {
    mobileFacetsDetails.forEach(detail => {
      if (detail.hasAttribute('open')) {
        const innerSummary = detail.querySelector('summary');
        if (innerSummary) innerSummary.click();
      }
    });

    let targetDetail = null;
    for (const detail of mobileFacetsDetails) {
      const labelSpan = detail.querySelector('summary span');
      if (labelSpan && labelSpan.innerText.trim().toLowerCase() === filterName) {
        targetDetail = detail;
        break;
      }
    }

    if (targetDetail) {
      const targetSummary = targetDetail.querySelector('summary');
      if (targetSummary && !targetDetail.hasAttribute('open')) {
        targetSummary.click();
        setTimeout(() => {
          targetDetail.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, 50);
});

// Split pane accordion and auto-open logic
document.addEventListener('click', function(event) {
  const summary = event.target.closest('.mobile-facets__main .mobile-facets__summary');
  if (summary) {
    const currentDetail = summary.closest('details');
    
    if (currentDetail.hasAttribute('open')) {
      // If it's already open, prevent the native toggle from closing it
      event.preventDefault();
    } else {
      // If it's closed, we will let it open natively, but close all others
      const allDetails = currentDetail.closest('.mobile-facets__main').querySelectorAll('details.mobile-facets__details');
      allDetails.forEach(detail => {
        if (detail !== currentDetail && detail.hasAttribute('open')) {
          detail.removeAttribute('open');
          const innerSummary = detail.querySelector('summary');
          if (innerSummary) innerSummary.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }
  
  const openMainDrawer = event.target.closest('.mobile-facets__open');
  if (openMainDrawer && !event.target.closest('.js-open-filter-drawer')) {
    const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper details');
    if (menuDrawer) {
      setTimeout(() => {
        const mobileFacetsDetails = menuDrawer.querySelectorAll('.mobile-facets__main > .mobile-facets__details');
        const anyOpen = Array.from(mobileFacetsDetails).some(detail => detail.hasAttribute('open'));
        if (!anyOpen && mobileFacetsDetails.length > 0) {
          mobileFacetsDetails[0].setAttribute('open', '');
          const firstSummary = mobileFacetsDetails[0].querySelector('summary');
          if (firstSummary) firstSummary.setAttribute('aria-expanded', 'true');
        }
      }, 50);
    }
  }
});

// Ensure active filter is opened if none explicitly selected
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.js-open-filter-drawer');
  if (trigger && trigger.getAttribute('data-filter-name') === 'none') {
    const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper details');
    if (menuDrawer) {
      setTimeout(() => {
        const mobileFacetsDetails = menuDrawer.querySelectorAll('.mobile-facets__main > .mobile-facets__details');
        const anyOpen = Array.from(mobileFacetsDetails).some(detail => detail.hasAttribute('open'));
        if (!anyOpen && mobileFacetsDetails.length > 0) {
          let targetDetail = null;
          for (const detail of mobileFacetsDetails) {
            if (detail.querySelector('input:checked') || detail.querySelector('.active-category')) {
              targetDetail = detail;
              break;
            }
          }
          if (!targetDetail) targetDetail = mobileFacetsDetails[0];

          targetDetail.setAttribute('open', '');
          const targetSummary = targetDetail.querySelector('summary');
          if (targetSummary) targetSummary.setAttribute('aria-expanded', 'true');
        }
      }, 100);
    }
  }
});

// Fix for custom close button in mobile drawer
document.addEventListener('click', function(event) {
  const closeBtn = event.target.closest('.mobile-facets__close');
  if (closeBtn) {
    const menuDrawer = document.querySelector('menu-drawer.mobile-facets__wrapper details');
    if (menuDrawer && menuDrawer.hasAttribute('open')) {
      const summaryToggle = menuDrawer.querySelector('summary.mobile-facets__open-wrapper');
      if (summaryToggle) summaryToggle.click();
    }
  }
});

// Sync custom age group URL parameters to standard filter checkboxes visually
document.addEventListener('DOMContentLoaded', function() {
  const params = new URLSearchParams(window.location.search);
  let sizes = [];
  if (params.has('baby_sizes')) sizes = sizes.concat(params.get('baby_sizes').split(','));
  if (params.has('toddler_sizes')) sizes = sizes.concat(params.get('toddler_sizes').split(','));
  if (params.has('kids_sizes')) sizes = sizes.concat(params.get('kids_sizes').split(','));
  
  if (sizes.length > 0) {
    sizes = sizes.map(s => s.trim().toLowerCase());
    const checkboxes = document.querySelectorAll('.mobile-facets__checkbox, .facet-checkbox input[type="checkbox"]');
    checkboxes.forEach(cb => {
      const val = cb.value.toLowerCase().replace(/\s+/g, '');
      sizes.forEach(size => {
        const sizeNoSpace = size.replace(/\s+/g, '');
        if (sizeNoSpace && val.includes(sizeNoSpace)) {
          cb.checked = true;
        }
      });
    });
  }
});


